import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/fermentations/$group_id/setup")({
  component: SetupLayout,
});

function SetupLayout() {
  return (
    <div className="flex h-full relative">
      <div className="flex-1 overflow-y-auto max-w-4xl">
        <Outlet />
      </div>
    </div>
  );
}
